

































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const RootVuex = namespace("root");
const forgetPassword = namespace("forgetPassword");
@Component({})
export default class FogetPasswordForm extends Vue {
  @RootVuex.Action menuListByRole;
  @forgetPassword.Action sendMsg;
  @forgetPassword.Action resetMemberPassword2;
  passwordType: boolean = true;
  errorMsg: any = "";
  mixinTimerError: any = null;
  loading: any = false;
  second: any = 60;
  timer = null;
  passwordType2: any = true;
  passwordType3: any = true;
  isFocus: any = false;
  passwordStatus: any = false;

  account: any = "";
  form: any = {
    memberCode: "",
    mobile: "",
    verificationCode: "",
    password: "",
    confirmPassword: ""
  };

  rules: any = {
    memberCode: [{ required: true, message: "用户名不能为空" }],
    mobile: [
      {
        required: true,
        message: "手机号不能为空"
      },
      {
        pattern: /^1\d{10}$/,
        message: "手机号格式不正确"
      }
    ],
    verificationCode: [{ required: true, message: "验证码不能为空" }],
    password: [
      { required: true, validator: this.validatePass, trigger: "blur" }
    ],
    confirmPassword: [
      { required: true, validator: this.validatePass2, trigger: "blur" }
    ]
  };
  pwdReg: any = /^(?=.*[a-zA-Z])(?=.*\d)[\S]+$/;
  // 密码提示pop的验证（icon的状态）
  get isPwdSuccess() {
    let { password } = this.form;
    let isRightPattern: any = this.pwdReg.test(this.form.password);
    let isRightLength: any = password.length >= 6 && password.length <= 20;
    if (isRightPattern && isRightLength) {
      return true;
    } else {
      return false;
    }
  }

  validatePass(rule, value, callback) {
    // 字母和数字，6位以上
    let pattern = /^(?=.*[a-zA-Z])(?=.*\d)[\S]+$/;
    if (value === "") {
      let error: any = "密码不能为空";
      callback(new Error(error));
    } else if (value.length < 6 || value.length > 20) {
      let error: any = "密码长度必须为6-20字符";
      callback(new Error(error));
    } else if (!pattern.test(value)) {
      let error: any = "新密码应为6-20位字母数字组成";
      callback(new Error(error));
    } else if (value.indexOf(this.account) !== -1) {
      let error: any = "密码不能包含用户名";
      callback(new Error(error));
    } else {
      callback();
    }
  }

  validatePass2(rule, value, callback) {
    if (value === "") {
      let error: any = "密码不能为空";
      callback(new Error(error));
    } else if (value !== this.form.password) {
      let error: any = "两次输入密码不一致";
      callback(new Error(error));
    } else {
      callback();
    }
  }
  created() {
    this.account = localStorage.getItem("memberCode");
    this.resumeTimer();
  }

  async handleResetSubmit() {
    let $form: any = this.$refs.form;
    $form.validate(async valid => {
      if (valid) {
        try {
          this.loading = true;
          let { memberCode, password, mobile, verificationCode } = this.form;
          await this.resetMemberPassword2({
            account: memberCode,
            dynamicCode: verificationCode,
            mobile,
            password
          });

          clearInterval(this.timer);
          localStorage.removeItem("sendSec");
          this.second = 60;
          this.isSend = false;

          this.$router.push({
            name: "ResetPasswordSuccess"
          });
        } finally {
          this.loading = false;
        }
      }
    });
  }

  showError(error) {
    let { graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors[0]) {
      const { message, code } = graphQLErrors[0];
      this.errorMsg = message;
      clearTimeout(this.mixinTimerError);
      this.mixinTimerError = setTimeout(() => {
        this.errorMsg = "";
      }, 3000);
    }
  }
  isSend: any = false;
  async sendMsgFn() {
    let $form: any = this.$refs.form;
    let isFormRight: any = true;
    $form.validateField("memberCode", errMsg => {
      if (errMsg) {
        isFormRight = false;
      }
    });
    $form.validateField("mobile", errMsg => {
      if (errMsg) {
        isFormRight = false;
      }
    });
    if (isFormRight) {
      await this.sendMsg({
        account: this.form.memberCode,
        mobile: this.form.mobile
      });
      this.isSend = true;
      this.$message.success("验证码成功发送");
      this.timerOutFn();
    }
  }
  timerOutFn() {
    this.timer = setInterval(() => {
      if (this.second > 1) {
        this.second--;
        localStorage.setItem("sendSec", this.second);
      } else {
        clearInterval(this.timer);
        localStorage.removeItem("sendSec");
        this.second = 60;
        this.isSend = false;
      }
    }, 1000);
  }
  // 已发送短信且在倒计时过程中，刷新页面，倒计时要记住之前的状态
  resumeTimer() {
    let oldSec: any = Number(localStorage.getItem("sendSec"));
    if (oldSec && oldSec > 1) {
      this.second = oldSec;
      this.isSend = true;
      this.timerOutFn();
    }
  }
  triggerPassword(name) {
    this[name] = !this[name];
  }
  blurInput() {
    this.isFocus = false;
  }
  focusInput(prop) {
    this.isFocus = true;
    this.focurClear(prop);
  }
  focurClear(prop) {
    const $form: any = this.$refs["form"];
    $form && $form.clearValidate(prop);
  }
}
